module.exports = [{
      plugin: require('../node_modules/@xavivars/gatsby-plugin-static-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
